import { Route, Routes } from "react-router-dom";
import ProductStockHistoryPage from "./ProductStockHistoryPage";
import SupplierStocksPage from "./SupplierStocksPage";
import SuppliersPage from "./SuppliersPage";

const ChinaV2Routes = () => {
  return (
    <Routes>
      <Route index element={<SuppliersPage />} />
      <Route path=":supplierId" element={<SupplierStocksPage />} />
      <Route
        path=":supplierId/:productId"
        element={<ProductStockHistoryPage />}
      />
    </Routes>
  );
};

export default ChinaV2Routes;
